<template lang="pug">
div
  h3 Tools
  p Integreer onze modules eenvoudig en snel binnen je website of applicatie.

  p Kom je er niet uit? Neem contact met ons op en we helpen je graag verder.

    v-layout
      v-layout(column)
        template
          h3.mt-5 Financial Lease (zakelijk)
          FormLink(domain='dealer.nl', isBusinessLease)

          Embed(domain='dealer.nl', isBusinessLease)

        template
          h3.mt-5 Krediet (particulier)
          FormLink(domain='dealer.nl')

          Embed(domain='dealer.nl')

          //- TODO VKM hier

    KeyValueTable(:data='formCodes', title='Uitbreiding codes', :headers='["Veld", "Uitleg", "Verplicht"]')

</template>

<script>
export default {
  components: {
    FormLink: require('./FormLink').default,
    Embed: require('./Embed').default,
    KeyValueTable: require('@/components/KeyValueTable').default
  },

  data () {
    return {
      formCodes: [
        ['domain', 'Domein van dit websiteprofiel', 'Ja'],
        ['leasetype', 'zakelijk/particulier', 'Ja'],
        ['leasebedrag', 'Het leasebedrag', 'Nee'],
        ['aanbetaling', 'Vooringevulde aanbetaling', 'Nee'],
        ['slottermijn', 'Vooringevuld slottermijn', 'Nee'],
        ['looptijd', 'Vooringevulde looptijd in maanden', 'Nee']
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
